import { useDataValue } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let id = useDataValue({
    viewPath: props.viewPath,
    context: 'selected',
    path: 'launcher_id',
  })
  let property_key = useDataValue({
    context: 'selected',
    viewPath: props.viewPath,
    path: 'key',
  })
  let location_id = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location._id',
  })

  let resource_id = useDataValue({
    viewPath: props.viewPath,
    context: 'steps',
    path: 'resource_id',
  })

  // Get the accumulated local values from previous steps
  let steps = useDataValue({
    viewPath: props.viewPath,
    context: 'steps',
    path: 'steps',
  })
  let current_index = useDataValue({
    viewPath: props.viewPath,
    context: 'steps',
    path: 'current_index',
  })
  let local =
    steps && current_index > 0
      ? Object.fromEntries(
          steps.slice(0, current_index).map(item => [item.key, item.value])
        )
      : null

  return {
    variables: {
      id,
      location_id,
      resource_id,
      local,
      property_key,
    },
  }
}
